export const rowSelected = (parameters) => {
  const { carrier_length } = parameters;
  if (carrier_length === '' || carrier_length === undefined) return null;

  let length = parseFloat(carrier_length);
  if (length < 0) return null;

  length = Math.ceil(length)
  return length - 1;
}

export const columnSelected = (parameters) => {
  const { carrier_width } = parameters;
  if (carrier_width === '' || carrier_width === undefined) return null;

  let width = parseFloat(carrier_width);
  if (width < 0) return null;

  width = Math.ceil(width)
  return width - 1;
}
